// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { productDetailsActionsBox } from "@awc/App/Widgets/ProductDetails/ProductDetailsActions";
import Share from "@awc/XDL/Icons/Share";
import { fontConfig } from "@awc/XDL/PreStyle/typography";
import {
    avoidBreakInsidePrintElement,
    boxSharedStyle,
    createLinkIconStyles,
    modalButtonsActionStyles,
} from "@awc/XDL/Utilities";
import { css } from "styled-components";

productDetailsActionsBox.qtyWrapper = {
    css: css`
        &&& {
            margin: 16px 0;
            .qty-field-wrapper {
                max-width: 100%;

                input {
                    padding-left: 8px !important;
                    text-align: start !important;
                }
            }
        }
    `,
};

productDetailsActionsBox.box = {
    container: {
        css: css`
            ${boxSharedStyle({ variant: "primary" })}
            ${avoidBreakInsidePrintElement}
        `,
    },
};

productDetailsActionsBox.productDetailsVariantContainer = {
    css: css`
        .variants-wrapper {
            margin-top: 16px;
        }
    `,
};

productDetailsActionsBox.buyNowtext = {
    variant: "h3",
};

productDetailsActionsBox.productPriceStyles = {
    wrapper: {
        css: css`
            display: flex;
            flex-direction: column;
            width: 100%;
            align-items: flex-end;
        `,
    },
    priceLabelText: {
        variant: "h3",
        css: css`
            text-align: end;
            margin-bottom: 8px;
        `,
    },
    price: {
        priceText: {
            size: fontConfig.fontSize.link,
            lineHeight: fontConfig.lineHeight.regular,
            color: "text",
            css: css`
                text-align: end;
                letter-spacing: 0;
                margin-bottom: 0;
            `,
        },
        unitOfMeasure: {
            unitOfMeasureText: {
                size: fontConfig.fontSize.regular,
                css: css`
                    white-space: nowrap;
                    letter-spacing: 0;
                    line-height: ${fontConfig.lineHeight.singleLineRegular};
                `,
            },
        },
    },
};

productDetailsActionsBox.buttonsWrapper = {
    css: css`
        display: flex;
        flex-direction: column;
        gap: 14px;
        margin-top: 8px;
    `,
};

productDetailsActionsBox.rfqBtn = productDetailsActionsBox.buyBtn = {
    variant: "secondary",
    css: css`
        width: 100%;
    `,
};

productDetailsActionsBox.productAddToCartButtonStyles = {
    variant: "primary",
    css: css`
        width: 100%;
    `,
};

productDetailsActionsBox.shareWrapper = {
    css: css`
        display: flex;
        justify-content: space-between;
        margin-top: 18px;
    `,
};

productDetailsActionsBox.formsWrapper = {
    css: css`
        &:not(:empty) {
            margin-top: 24px;
        }
    `,
};

productDetailsActionsBox.shareLink = {
    link: {
        ...createLinkIconStyles({
            icon: Share,
            linkStyles: {
                typographyProps: {
                    weight: fontConfig.weight.regular,
                    size: fontConfig.fontSize.small,
                    lineHeight: fontConfig.lineHeight.singleLineSmall,
                },
                icon: {
                    position: "left",
                    iconProps: {
                        size: 13,
                        css: css`
                            &,
                            svg {
                                width: 11px;
                            }
                        `,
                    },
                },
            },
        }),
    },
    buttonsWrapper: {
        ...modalButtonsActionStyles.buttonsGridItem,
    },
};

productDetailsActionsBox.productLeadTime = {
    text: {
        size: fontConfig.fontSize.singleLineRegular,
        lineHeight: fontConfig.lineHeight.regular,
        weight: fontConfig.weight.bold,
        css: css`
            display: block;
            text-align: right;
        `,
    },
};

productDetailsActionsBox.productAddToListStyles = {
    link: {
        typographyProps: {
            size: fontConfig.fontSize.small,
            lineHeight: fontConfig.lineHeight.singleLineSmall,
        },
    },
};
